<template>

</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {

        }        
    },

    created() {
        
    },

    mounted(){
        /** 聚量广告  **/
        this.showAdertis();
    },

    methods: {
        /** 聚量广告  **/
        showAdertis(){

            let d = {
                app_key: '98dd5fd43a7148b4a214fcf6ccd4f5fc', //流量方appKey 请联系商务人员获取
                adid: '6353651',//广告位ID 请联系商务人员获取

            }

            axios({
              method:'get',
              url:'https://ads.lejuliang.com/getAd',
              params: d,
            }).then(function(response) {
                console.log("=================================")
                console.log(response);
                if(response.data.return_code == 200){
                    // window.location.href = response.data.ads[0].landing_page;
                }
            });
          }

    },

}
</script>